export default {
  overview: {
    title: "Einstellungen",
    form: {
      company: {
        title: "Unternehmen",
      },
      logo: {
        title: "Logo",
        upload: "Logo hochladen",
        change: "Logo ändern",
        remove: "Logo entfernen",
        hint: "PNG oder JPEG, bis zu 2 MB.",
      },
      currency_title: "Währungs Einstellungen",
      currency_hint:
        "Standardwährung und Währungs-Schema legen fest, wie Beträge angezeigt werden. Das Schema bestimmt Trennzeichen und Stellung des Währungszeichens.",
      default_user_role: "Standard-Rolle",
      default_user_role_hint:
        "Ist bei jedem neu angelegten Login-Benutzer schon eingetragen und lässt sich im Formular noch ändern.",
      default_currency: "Standardwährung",
      currency_locale: "Währungs Schema",
      first_day_of_week: "Wochenbeginn",
      first_day_of_week_hint:
        "Gilt für jede Datumsauswahl, für Kalender, für Meine Zeiten und für die Wochentabelle der Projektkosten.",
      week_start: {
        monday: "Montag",
        sunday: "Sonntag",
      },
      calculation: {
        title: "Mitlaufende Nachkalkulation",
        employer_contribution: "Arbeitgeberanteil (Sozialversicherung)",
        employer_contribution_hint:
          "Aufschlag auf die Personalkosten für die realen Vollkosten. Wird auf alle Mitarbeiter angewandt, sofern nicht individuell überschrieben. 0 % = kein Aufschlag.",
      },
      // Tagesmeldungen aus der App: ob der Standort Pflicht ist (`daySubmissionLocationRequired`)
      day_submission: {
        title: "Tagesmeldungen",
        location_required: "Standort mit jeder Tagesmeldung verlangen",
        location_required_hint:
          "Die App nimmt erst auf, wenn der Mitarbeiter den Standort freigegeben und eingeschaltet hat. Findet das Handy keinen, sendet sie trotzdem und reicht ihn bis zu 15 Minuten nach dem Senden nach.",
      },
      // Stempeln in der App: ob Kommen und „Kolonne nachtragen“ den Standort brauchen (`timeEntryLocationRequired`).
      // Gehen nie: wer nicht ausstempeln kann, dessen Tag läuft weiter.
      time_entry: {
        title: "Zeiterfassung",
        location_required: "Standort bei der Zeiterfassung in der App verlangen",
        location_required_hint:
          "Die App stempelt das Kommen und trägt eine Kolonne erst nach, wenn der Standort freigegeben und eingeschaltet ist. Findet das Handy keinen, tut sie es trotzdem, und Gehen ist immer möglich.",
      },
      address: {
        title: "Unternehmens Adresse",
        hint: "Diese Anschrift steht als Absender auf jeder PDF, etwa auf Rechnungen und [[cr.datpl]].",
        street: "Straße",
        houseNumber: "Hausnummer",
        postcode: "PLZ",
        place: "Ort",
        country: "Land",
        state: "Bundesland",
      },
      document_details: {
        title: "Geschäftsangaben",
        hint: "Für die Fußzeile Ihrer PDF-Dokumente: Ein Briefpapier druckt eine Angabe dort, wo einer seiner Blöcke sie nennt.",
        phone: "Telefon",
        email: "E-Mail",
        website: "Website",
        managingDirector: "Geschäftsführung",
        registerCourt: "Registergericht",
        registerNumber: "Registernummer",
        vatId: "USt-IdNr.",
        taxNumber: "Steuernummer",
        bankName: "Bank",
        iban: "IBAN",
        bic: "BIC",
      },
      save: "Speichern",
    },
  },
  general: {
    title: "Allgemein",
    max_storage_size: "Maximale Datei-Speicher größe",
  },
  // Einstellungen → Bezeichnungen: wie der Betrieb seine Berichte nennt (services/terminology.js).
  terminology: {
    title: "Bezeichnungen",
    section: "Unterlagen",
    hint: "Die Bezeichnung steht überall in Lewara, in Benachrichtigungen und E-Mails und auf neu gedruckten PDFs. Schon gedruckte Berichte bleiben, wie sie sind. Jede Sprache hat eigene Bezeichnungen; PDFs und E-Mails verwenden die deutschen.",
    language: "Sprache der Bezeichnungen",
    columns: {
      record: "Unterlage",
      name: "Bezeichnung",
      plural: "Mehrzahl",
      article: "Artikel",
    },
    records: {
      HOURLY_WAGE_REPORT: "Arbeiten nach Aufwand, vom Kunden bestätigt",
      CONSTRUCTION_REPORT: "Tägliche Dokumentation der Baustelle",
      HOURLY_WAGE_INVOICE: "Abrechnung der Arbeiten nach Aufwand",
    },
    articles: {
      MASCULINE: "der",
      FEMININE: "die",
      NEUTER: "das",
    },
    default: "Standard",
    // Im Sprachmenü neben jeder Sprache, in der der Betrieb Unterlagen anders nennt; sonst steht dort „Standard“.
    custom_count: "{n} eigene",
    too_long: "Höchstens {max} Zeichen",
    // Je Sprache der Bezeichnungen, nicht der Oberfläche: deutsche Namen sind ein Wort, weil die Endungen
    // (des Regiescheins, den Regiescheinen) ans Ende gehängt werden (services/terminology.js).
    invalid: {
      de: "Ein Wort, zusammengesetzt oder mit Bindestrich",
      en: "Nur Buchstaben, Ziffern, Leerzeichen und . & / ' -",
    },
    invalid_save: "Eine Bezeichnung ist nicht gültig. Bitte das markierte Feld korrigieren.",
    preview_label: "So liest es sich:",
    // Mit Absicht Artikel, Dativ und Mehrzahl in einem Satz: genau das, was ein eigener Name falsch
    // machen kann, soll hier auffallen und nicht erst in der Anwendung.
    preview:
      "[[hwr:Dieser/Diese/Dieses]] [[hwr]] hängt [[cr:am/an der/am]] [[cr]] vom Montag. Aus drei [[hwr.datpl]] wird [[hwi:ein/eine/ein]] [[hwi]].",
  },
  absence: {
    singular: "Abwesenheitsart",
    title: "Abwesenheitsarten",
    default_types: "Standard Abwenseheitsarten",
    custom_types: "Benutzerdefinierte Abwesenheitsarten",
    default_types_hint:
      "Bringt jeder Arbeitsbereich mit. Die Farben erscheinen in der Einsatzplanung und bei freien Tagen in der Zeiterfassung.",
    custom_types_hint: "Eigene Gründe für Abwesenheiten, mit Name und Farbe. Das Plus speichert sofort.",
    no_custom_types: "Keine benutzerdefinierten Abwesenheitsarten vorhanden",
    form: {
      name: "Neue Abwesenheitsart",
      paid: "Bezahlt",
    },
    name: "Name",
    color: "Farbe",
    // Entscheidet über Zahlen auf dem Arbeitszeitkonto. Überstundenausgleich ist absichtlich unbezahlt:
    // die Stunden kommen aus den Überstunden, die schon auf dem Konto stehen.
    paid: "Bezahlt",
    paid_hint:
      "Bezahlte Abwesenheiten schreibt die Zeiterfassung dem Arbeitszeitkonto gut, bis zum Soll des Tages. Die Änderung gilt auch für vergangene Tage.",
  },
  rights: {
    title: "Berechtigungen",
    roles_hint:
      "Eine Rolle bündelt Rechte und gilt für alle Personen, die sie haben. Welche Rolle jemand hat, steht am Mitarbeiter. Administrator hat immer alle Rechte.",
    // Steht ohne EDIT_ROLES anstelle von "Erstelle eine neue Rolle": die Rollen lassen sich öffnen
    // und lesen, aber nicht ändern. Das Recht hat nur die Rolle Administrator.
    edit_denied: "Nur die Rolle Administrator kann Rollen anlegen, ändern und löschen.",
    table: {
      id: "Rollen ID",
      name: "Rollen",
    },
    detail: {
      title: "Rolle",
      subtitle: "Id",
      category: {
        permission: "Berechtigung",
        show: "Anzeigen",
        edit: "Bearbeiten",
        delete: "Löschen",
      },
      input: "Rollenname",
      error: "Bitte Name hier eingeben",
      no_selected: "Keine Rolle ausgewählt",
    },
    actions: {
      create: "Erstelle eine neue Rolle",
      save: "Speichern",
      cancel: "Abbrechen",
      delete: {
        title: "Löschen der Rolle",
        text: "Sind sie sich sicher dass sie die Rolle löschen wollen?",
        agree: "Zustimmen",
        disagree: "Abbrechen",
      },
    },
  },
  pdf: {
    title: "PDF-Vorlagen",
    back: "Zurück zu den PDF-Vorlagen",
    name: "Name",
    edit: "Bearbeiten",
    copy: "Kopieren",
    delete: "Löschen",
    save: "Speichern",
    save_copy: "Als Kopie speichern",
    undo: "Rückgängig",
    redo: "Wiederholen",
    built_in: "Mitgeliefert",
    letterhead: "Briefpapier",
    letterhead_hint:
      "Logo, Absender, Fußzeile, Schrift und Farben. Mehrere Vorlagen können dasselbe Briefpapier verwenden.",
    open_letterhead: "Briefpapier öffnen",
    sample_document: "Musterdokument",
    new_text: "Neuer Text",
    color_none: "Keine",
    color_clear: "{name} entfernen",
    compact_notice: "Ein Briefpapier gestalten Sie an einem größeren Bildschirm. Hier sehen Sie, wie es gedruckt wird.",
    letterhead_editor: { title: "Briefpapier" },
    template_editor: { title: "PDF-Vorlage" },
    mode: { design: "Gestalten", pdf: "PDF" },
    system_banner: {
      letterhead:
        "Das ist das mitgelieferte Briefpapier. Was Sie ändern, wird als eigenes Briefpapier gespeichert; das mitgelieferte bleibt, wie es ist.",
      template:
        "Das ist die mitgelieferte Vorlage. Was Sie ändern, wird als eigene Vorlage gespeichert; die mitgelieferte bleibt, wie sie ist.",
      template_default:
        "Das ist die mitgelieferte Vorlage. Was Sie ändern, wird als eigene Vorlage gespeichert und ab dann gedruckt; die mitgelieferte bleibt, wie sie ist.",
    },
    letterheads: {
      title: "Briefpapiere",
      hint: "Ein Briefpapier legt fest, wie jede Seite aussieht: Logo, Absender, Titel, Fußzeile, Schrift und Farben.",
      add: "Neues Briefpapier",
      used_by: "Von keiner Vorlage verwendet | Von einer Vorlage verwendet | Von {n} Vorlagen verwendet",
      system_meta: "Grundlage der mitgelieferten Vorlagen",
      documents: "Für kein Dokument | Für ein Dokument | Für {n} Dokumente",
      delete_in_use: "Löschen: von einer Vorlage verwendet | Löschen: von {n} Vorlagen verwendet",
      delete_title: "Briefpapier löschen?",
      delete_text: "„{name}“ und seine Bilder werden gelöscht. Gedruckte Dokumente bleiben, wie sie sind.",
    },
    documents: {
      title: "Dokumente",
      hint: "Jede Zeile zeigt, womit das Dokument gedruckt wird. Eine weitere Vorlage wählt ein Projekt in seiner Konfiguration. Änderungen gelten für künftige Drucke, gedruckte Berichte bleiben, wie sie sind.",
      customize: "Anpassen",
      add: "Weitere Vorlage anlegen",
      others: "Eine weitere Vorlage | {n} weitere Vorlagen",
    },
    use: {
      action: "Für Dokumente verwenden",
      title: "„{name}“ verwenden",
      subtitle: "Die gewählten Dokumente drucken künftig auf diesem Briefpapier.",
      current: "Bisher: {name}",
      already: "Druckt schon darauf",
      submit: "Verwenden",
    },
    templates: {
      default_chip: "Standard",
      make_default: "Als Standard verwenden",
      on_letterhead: "Briefpapier: {name}",
      delete_title: "Vorlage löschen?",
      delete_text: "„{name}“ wird gelöscht. Gedruckte Dokumente bleiben, wie sie sind.",
      delete_projects:
        "Ein Projekt druckt mit ihr und nimmt danach den Standard. | {n} Projekte drucken mit ihr und nehmen danach den Standard.",
      delete_default: "Sie ist der Standard: Danach drucken alle Projekte ohne eigene Wahl mit „Lewara Standard“.",
    },
    preview: {
      title: "Vorschau",
      action: "Vorschau",
      empty: "Die Vorschau erscheint gleich.",
      failed: "Die Vorschau konnte nicht erstellt werden.",
      overflow: "Zu klein für den Text: {names} | Zu klein für ihren Text: {names}",
    },
    // Was ein Entwurf nicht sein darf, bevor das Backend ihn überhaupt ansieht: Vorschau und Speichern zeigen es.
    problem: {
      name_missing: "Name fehlt",
      name_too_long: "Name länger als {max} Zeichen",
      blocks: "Mehr als {max} Blöcke",
      theme_color: "Farbe ungültig (Gestaltung)",
      frame: "Inhaltsbereich: Rand außerhalb der Seite",
      number: "{name}: Maß fehlt",
      off_page: "{name}: außerhalb der Seite",
      size: "{name}: größer als die Seite",
      font_size: "{name}: Schriftgröße 4 bis 72 pt",
      stroke: "{name}: Linienstärke 0 bis 20 pt",
      text_too_long: "{name}: Text länger als {max} Zeichen",
      color: "{name}: Farbe ungültig",
      headline_too_long: "Überschrift länger als {max} Zeichen",
      label_too_long: "{name}: Beschriftung länger als {max} Zeichen",
      labels: "{name}: mehr als {max} Beschriftungen",
      field_too_long: "Feldname länger als {max} Zeichen",
    },
    sections: {
      title: "Inhalt",
      hint: "Abschnitte ein- und ausblenden, umsortieren und einzeln anpassen. Was ein Dokument ausmacht, bleibt immer sichtbar.",
      move: "{name} verschieben (Pfeiltasten)",
      required: "Wird immer gedruckt",
      hidden_fields: "ein Feld ausgeblendet | {n} Felder ausgeblendet",
      headline: "Überschrift",
      align: "Ausrichtung",
      fields: "Felder",
      field_name: "Bezeichnung von {name}",
    },
    align: {
      DOCUMENT: "Wie im Dokument",
      LEFT: "Linksbündig",
      CENTER: "Zentriert",
      RIGHT: "Rechtsbündig",
      JUSTIFIED: "Blocksatz",
    },
    valign: { TOP: "Oben", MIDDLE: "Mitte", BOTTOM: "Unten" },
    signature: {
      title: "Unterschrift",
      none_by_default: "Nur von einem Unterschrift-Block, der dieses Dokument unter „Dokumente“ nennt.",
      on_letterhead: "Die Beschriftungen stehen am Unterschrift-Block des Briefpapiers.",
      visible: "Unterschriftszeile drucken",
    },
    frame: {
      title: "Inhaltsbereich",
      hint: "Abstand des Dokumentinhalts vom Seitenrand: die gestrichelte Fläche auf der Seite, deren Ränder Sie ziehen. Was außerhalb liegt, gehört dem Briefpapier.",
      template_hint: "Abstand des Dokumentinhalts vom Seitenrand. Was außerhalb liegt, gehört dem Briefpapier.",
      from_template: "Inhaltsbereich hier aus der Vorlage „{name}“",
      exact: "Genau eingeben",
      like_letterhead: "Wie im Briefpapier",
      own: "Eigener für diese Vorlage",
      change: "Ändern",
      first: "Erste Seite",
      following: "Folgeseiten",
      top: "Oben",
      bottom: "Unten",
      left: "Links",
      right: "Rechts",
    },
    canvas: {
      label: "Seite des Briefpapiers. Pfeiltasten verschieben den gewählten Block, Entf entfernt ihn.",
    },
    pages: { ALL: "Alle Seiten", FIRST: "Erste Seite", FOLLOWING: "Folgeseiten" },
    palette: {
      add: "Hinzufügen",
      texts: "Texte",
      shapes: "Bilder und Formen",
      blocks: "Auf der Seite",
      forward: "Nach vorn",
      backward: "Nach hinten",
    },
    kind: {
      TEXT: "Text",
      LOGO: "Logo",
      IMAGE: "Bild",
      LINE: "Linie",
      RECT: "Fläche",
      DOCUMENT_TITLE: "Titel und Nummer",
      PAGE_NUMBER: "Seitenzahl",
      SIGNATURE: "Unterschrift",
    },
    inspector: {
      duplicate: "Duplizieren",
      delete: "Entfernen",
      x: "Links",
      y: "Oben",
      width: "Breite",
      height: "Höhe",
      text: "Text",
      page_format: "Format",
      insert_field: "Feld einfügen",
      font_size: "Schriftgröße",
      bold: "Fett",
      italic: "Kursiv",
      text_color: "Textfarbe",
      title_text: "Titel",
      number_text: "Nummer",
      signature_label: "Beschriftung {n}",
      signature_add: "Beschriftung",
      signature_remove: "Beschriftung entfernen",
      signature_reset: "Wie im jeweiligen Dokument",
      signature_note:
        "Gilt für alle Dokumente dieses Briefpapiers. Dokumente ohne eigene Unterschrift (Kostenaufstellungen, [[hwi]]) drucken sie nur, wenn sie unter „Dokumente“ gewählt sind.",
      logo_workspace: "Firmenlogo",
      logo_lewara: "Lewara",
      logo_missing:
        "Noch kein Firmenlogo: Bis eines hochgeladen ist (Einstellungen → Allgemein), steht hier das Lewara-Logo.",
      upload_image: "Bild hochladen",
      delete_image: "Bild löschen",
      fill: "Füllung",
      stroke: "Linie",
      stroke_width: "Stärke",
      where: "Wo",
      pages: "Seiten",
      documents: "Dokumente",
      all_documents: "Alle Dokumente",
      background: "Hinter dem Inhalt",
    },
    theme: {
      title: "Gestaltung",
      font: "Schrift",
      font_hint:
        "Helvetica ist die bisherige Schrift und kennt nur westeuropäische Zeichen. Die Liberation-Schriften drucken jedes Zeichen.",
      text_color: "Textfarbe",
      headline_style: "Abschnittsüberschrift",
      accent: "Hintergrund der Überschrift",
      primary: "Linie unter der Überschrift",
      highlight: "Positionsleiste der Abrechnung",
      highlight_dark: "Summenleiste der Abrechnung",
    },
    font: {
      HELVETICA: "Helvetica (bisher)",
      LIBERATION_SANS: "Liberation Sans (wie Arial)",
      LIBERATION_SERIF: "Liberation Serif (wie Times)",
      LIBERATION_MONO: "Liberation Mono (wie Courier)",
    },
    headline_style: {
      TINTED_BAR: "Farbiger Balken mit Linie",
      RULE: "Nur Linie",
      PLAIN: "Nur Text",
    },
    placeholder_group: { company: "Firma", document: "Dokument", page: "Seite" },
    placeholder: {
      company_name: "Firmenname",
      company_street: "Straße",
      company_houseNumber: "Hausnummer",
      company_postcode: "PLZ",
      company_place: "Ort",
      company_phone: "Telefon",
      company_email: "E-Mail",
      company_website: "Website",
      company_managingDirector: "Geschäftsführung",
      company_registerCourt: "Registergericht",
      company_registerNumber: "Registernummer",
      company_vatId: "USt-IdNr.",
      company_taxNumber: "Steuernummer",
      company_bankName: "Bank",
      company_iban: "IBAN",
      company_bic: "BIC",
      document_title: "Titel des Dokuments",
      document_number: "Nummer des Dokuments",
      document_date: "Datum des Dokuments",
      print_date: "Druckdatum",
      project_number: "Projektnummer",
      project_name: "Projektname",
      customer_name: "Auftraggeber",
      employee_name: "Mitarbeiter",
      page_number: "Seitenzahl",
      page_total: "Gesamtseitenzahl",
    },
    document: {
      CONSTRUCTION_REPORT: "[[cr]]",
      CONSTRUCTION_REPORT_COST: "Kosten- und Erlösaufstellung ([[cr]])",
      HOURLY_WAGE_REPORT: "[[hwr]]",
      HOURLY_WAGE_REPORT_COST: "Kosten- und Erlösaufstellung ([[hwr]])",
      HOURLY_WAGE_INVOICE: "[[hwi]]",
      MONTHLY_TIMESHEET: "Monatsnachweis",
      SERVICE_CATALOG_PROGRESS: "Leistungsstand",
    },
  },
}
